import { useSelector } from '@xstate/react'
import { ReviewTemplateForm } from 'components/ReviewTemplateFormModal/ReviewTemplateForm/ReviewTemplateForm'
import { isEqual } from 'lodash'
import { templateFormDataFromContext } from '../machine'
import { useReviewsWizard } from '../ReviewsWizardProvider'
import { EventId } from '../machineTypes'
import { useCreateReviewTemplate } from 'hooks/queries/reviewTemplates/useCreateReviewTemplate'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { ReviewTemplate } from 'types'
import { Modal } from 'almanac-ui/Modal'
import { useRef } from 'react'
import { Button } from 'components/Button'

interface Props {
  workspaceId: number
}

export const TemplateForm = ({ workspaceId }: Props) => {
  const { service, isLoading } = useReviewsWizard()
  const template = useSelector(service, (state) => templateFormDataFromContext(state.context), isEqual)
  const onSuccess = (reviewTemplate: ReviewTemplate) => {
    showToastMessage('New Template Created')
    service.send({ type: EventId.TEMPLATE_SAVED, reviewTemplate })
  }
  const onError = () => {
    showToastMessage('Failed to save Template', 'error')
  }
  const { mutate } = useCreateReviewTemplate({ workspaceId, onSuccess, onError, retry: false })
  const footer = useRef<HTMLDivElement>(null)

  return (
    <>
      <Modal.Top>
        <Modal.BackButton onPress={() => service.send(EventId.BACK)} />
      </Modal.Top>
      <Modal.Header title="Save as review template" />
      <Modal.Content>
        <ReviewTemplateForm initialTemplate={template} onSubmit={mutate} footerPortal={footer} />
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button variant="tertiary" size="xl" onPress={() => service.send(EventId.BACK)} isDisabled={isLoading}>
            Back
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <div ref={footer} />
        </Modal.FooterContent>
      </Modal.Footer>
    </>
  )
}
